<div class="modal active facility">
  <div class="modal__container">
    <div class="fields">
      <h2 class="title">Network Configuration</h2>
      <div class="close" (click)="cancelConfiguration()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off"  name="ngNetworkForm" #ngForm="ngForm" id="NetworkForm" class="active">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>Proxy Definition</h4>
              </div>
                <div class="input-fields">
                    <div>
                      <label for="">Address</label>
                      <input
                        maxlength="10"
                        [(ngModel)]="configurationController.currentConfiguration.network.address"
                        (change)='updateField("address", $event.target.value)'
                        type="text"
                        name="Address"
                        id="Address"
                        class="AddressInput"
                      />
                    </div>
                </div>
                <div>
                  <input type="checkbox"
                    (change)='updateCheckboxField("useProxyServer")'
                    [(ngModel)]="configurationController.currentConfiguration.network.useProxyServer" />
                    <label for=""> Use Proxy Server</label>
                </div>
              </div>
              <div>
                <div>
                  <label for = "">Port</label>
                  <input
                  maxlength="10"
                  [(ngModel)]="configurationController.currentConfiguration.network.port"
                  (change)='updateField("port", $event.target.value)'
                  type="number"
                  name="Port"
                  id="Port"
                  class="PortInput"
                  />
                </div>
                <div>
                  <label for = "">Exception</label>
                  <input
                  maxlength="10"
                  [(ngModel)]="configurationController.currentConfiguration.network.exceptions"
                  (change)='updateField("exceptions", $event.target.value)'
                  type="text"
                  name="Exceptions"
                  id="Exceptions"
                  class="ExceptionsInput"
                  />
                </div>
              </div>
              <div>
                <div>
                  <input type="checkbox"
                  [(ngModel)]="configurationController.currentConfiguration.network.requiresAuthentication"
                  (change)='updateCheckboxField("requiresAuthentication")'>
                  <label for=""> Requires Authentication</label>
                </div>
              </div>
              <div>
                <label for=""> User</label>
                <input type="text"
                [(ngModel)]="configurationController.currentConfiguration.network.user"
                (change)='updateField("user", $event.target.value)'

                >
              </div>
              <div>
                <label for =""> Password</label>
                <input maxlength="10"
                [(ngModel)]="configurationController.currentConfiguration.network.exceptions"
                (change)='updateField("exceptions", $event.target.value)'
                type="password"
                name="Password"
                id="Exceptions"
                class="ExceptionInput"/>


              </div>
            </div>
          <div class="fields__btn">
            <button type="submit" [ngClass]="ngForm.form.valid ? 'blue' : 'gray'" (click)="saveConfiguration()" [disabled]="!ngForm.form.valid">
              Save
            </button>
            <button class="gray" (click)="cancelConfiguration()">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

